import { OwnerModelDTO, RealEstateAssetOptionDTO } from '../api/useIncomeQuery';

interface Params {
  associatedAssetId: string | null | undefined;
  assetOptions: RealEstateAssetOptionDTO[];
  formOwnerModel?: OwnerModelDTO[];
}

export const getRealEstateIncomeOwnerModel = ({
  associatedAssetId,
  assetOptions,
  formOwnerModel,
}: Params): OwnerModelDTO[] => {
  if (formOwnerModel?.length) {
    return formOwnerModel;
  }

  if (associatedAssetId) {
    const assetOption = assetOptions.find(({ value }) => value === associatedAssetId);
    if (assetOption?.ownerModel?.length) {
      return assetOption.ownerModel;
    }
  }

  return [];
};
